// extracted by mini-css-extract-plugin
module.exports = {"cardGroup":"GroupFileContainer_cardGroup__pj6SI","customInfinitscroll":"GroupFileContainer_customInfinitscroll__1ylGT"};